import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { guideSteps } from "@/mocks/home";

export default function GuideSection() {
  return (
    <section id="guide" className="w-full bg-background-50 py-14 md:py-20">
      <div className="max-w-content mx-auto px-4 md:px-8">
        <Reveal>
          <SectionHeading
            eyebrow="观影指南"
            title="四步看完一部片，操作都在同一页"
            desc="从筛选到续看，整个流程不需要跳转到其他页面。下面把每一步会用到的地方按顺序列出来，照着做即可。"
          />
        </Reveal>

        <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {guideSteps.map((step, index) => (
            <Reveal key={step.id} delay={index * 80}>
              <div className="relative h-full rounded-lg bg-background-100 border border-background-200 p-5">
                <span className="font-heading text-3xl font-bold text-primary-200">{step.index}</span>
                <h3 className="mt-3 font-heading text-base font-bold text-foreground-950">{step.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
                {index < guideSteps.length - 1 && (
                  <i className="hidden lg:flex ri-arrow-right-line absolute -right-3 top-1/2 -translate-y-1/2 text-background-400 z-10 bg-background-50 w-6 h-6 items-center justify-center rounded-full"></i>
                )}
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120}>
          <div className="mt-8 flex flex-col sm:flex-row items-start sm:items-center gap-4 rounded-lg bg-accent-100 border border-accent-200 p-5">
            <span className="w-11 h-11 shrink-0 flex items-center justify-center rounded-md bg-accent-500 text-primary-950">
              <i className="ri-lightbulb-line text-xl"></i>
            </span>
            <p className="text-sm text-foreground-800 leading-relaxed">
              <strong className="text-foreground-950">小提示：</strong>
              网络波动时不必手动反复切档，把清晰度保持在自动模式，播放器会在几秒内完成平滑调整，观看进度不会中断。
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}